import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  validationState?: "success" | "error" | "warning" | null;
  controlId?: string;
  className?: string;
};

const FormGroup = ({
  validationState,
  className,
  children,
  controlId,
  ...props
}: PropsWithChildren<Props>) => (
  <div
    {...props}
    className={clsx({
      "form-group": true,
      [`${className ? className : ""}`]: className,
    })}
  >
    {children}
  </div>
);

export default FormGroup;
